/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const StripeWebhookRequest = core.serialization.object({
    id: core.serialization.string(),
    idempotencyKey: core.serialization.property("idempotency_key", core.serialization.string()),
});
